<template>
    <div class="container row">
        <div class="form-group col-11 col-md-12">
            <a :href="add_route">
            <button type="button" class="col-12 col-md-auto pull-right btn btn-primary">
                {{$lang('Dodaj osobę')}}
            </button></a>
        </div>

        <table class="table simple-table table-striped table-sm">
            <thead class="thead-dark">
            <tr>
                <th scope="col">{{$lang('Nazwisko')}}</th>
                <th scope="col">{{$lang('Imię')}}</th>
                <th scope="col">{{$lang('E-mail')}}</th>
                <th scope="col">{{$lang('Biblioteka')}}</th>
                <th scope="col">{{$lang('Akcje')}}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="person in people">
                <td :data-title="$lang('Nazwisko')">{{person.surname}}</td>
                <td :data-title="$lang('Imię')">{{person.name}}</td>
                <td :data-title="$lang('E-mail')">{{person.email}}</td>
                <td :data-title="$lang('Nazwa Biblioteki')">{{person.libraryName}}</td>
                <td>
                    <a v-if="admin" class="mr-3" href="#" data-toggle="modal" v-on:click="selectedPerson=person"
                       data-target="#delete_modal">{{$lang('Usuń')}}</a>
                    <a :href="edit_route +'/'+ person.id">{{$lang('Edytuj')}}</a>
                </td>
            </tr>
            </tbody>
        </table>
        <person-delete-modal
            :person=selectedPerson
            :delete_route="delete_route"
            :pre_delete_route="pre_delete_route"
            :csrf=csrf
        ></person-delete-modal>
    </div>
</template>

<script>

    export default {
        name: 'library-persons',
        props: ['csrf', 'admin', 'user', 'get_people_route', 'edit_route', 'add_route', 'delete_route', 'pre_delete_route', 'pre_delete_route'],
        data() {
            return {
                people: [],
                selectedPerson: null
            }
        },
        methods: {
            getPeople() {
                let self = this;
                axios({
                    method: 'get',
                    url: self.get_people_route,
                })
                    .then(function (response) {
                        self.people = response.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },
        },
        created() {
            this.getPeople();
        }
    }
</script>
